import { createContext, useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "./auth";

const AuthModalCtx = createContext(null);

export function AuthModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [onAuthed, setOnAuthed] = useState(null);
  const { user } = useAuth();
  const navigate = useNavigate();

  const requireAuth = (callback) => {
    // Não logado → abre login
    if (!user) {
      setOnAuthed(() => callback);
      setOpen(true);
      return;
    }
    // Aprovado → executa callback
    if (user.status === "ativo_verificado") {
      callback?.();
      return;
    }
    // Aguardando validação → não abre modal, só avisa
    const kycStatus = user.kyc_status || "";
    const isPending = kycStatus === "aguardando_validacao" || user.status === "aguardando_validacao";
    if (isPending) {
      toast.message("Cadastro em análise", {
        description: "Você poderá alugar assim que o suporte aprovar seus documentos. Costuma levar até 24h.",
        duration: 6000,
      });
      return;
    }
    // Rejeitado → manda para edição de perfil para reenviar
    if (kycStatus === "rejected") {
      toast.error("Seu documento foi rejeitado. Reenvie no seu perfil.");
      navigate("/perfil/editar");
      return;
    }
    // Pendente/OTP/Doc → abre modal para completar
    setOnAuthed(() => callback);
    setOpen(true);
  };

  const close = () => {
    setOpen(false);
    setOnAuthed(null);
  };

  const completed = () => {
    const cb = onAuthed;
    setOpen(false);
    setOnAuthed(null);
    cb?.();
  };

  const value = useMemo(
    () => ({ open, setOpen, requireAuth, close, completed }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [open, user],
  );

  return <AuthModalCtx.Provider value={value}>{children}</AuthModalCtx.Provider>;
}

export const useAuthModal = () => useContext(AuthModalCtx);
